import {
    Flex,
    Icon,
    Link,
    Popover,
    PopoverPlacement,
    PriorityIcon
} from '@priority-software/priority-style-react';
import {priority} from '@priority-software/priority-proto-api/lib';
import React from 'react';
import {ButtonWithTooltip} from '../../../../_legacy/FormHeader/components/UniqueScreensHeader';
import {getUsername} from '../../../../_shared/GWTBridge/invoke/genPage';
import texts from '../../texts';
import {IReport} from '../../types';
import MenuActions from './ActionsMenu';
import styles from './styles.module.scss';
import {isRTL} from '../../../../Localization';
import {createDataTestId} from '../../../../utils/dataTestId';

interface Props {
    report: IReport;
    onEdit: (report: IReport) => void;
    onRun: (id: string, title: string, type: priority.netitems.nrest.RepType) => void;
    onDelete: (id: number | Long) => void;
    onDuplicate: (id: number | Long) => void;
}
const RowActions = ({report, onDelete, onDuplicate, onRun, onEdit}: Props) => {
    const userName = getUsername();
    return (
        <div className={styles.tableItem}>
            <Flex justifyContent="flex-end" componentClasses={styles.actionsWrapper}>
                {userName === report.userName &&
                    (report.isOldReport ? (
                        <Popover
                            {...createDataTestId('popover-row-action-container', true)}
                            rtl={isRTL()}
                            zIndex={1000000}
                            hoverable
                            placement={PopoverPlacement.topEnd}
                            title={
                                <div {...createDataTestId('popover-continue-title', false)}>
                                    {texts.oldGenToolTip}
                                </div>
                            }
                            content={
                                <div {...createDataTestId('popover-continue-text', false)}>
                                    {texts.oldGenEditToolTip}
                                </div>
                            }
                        >
                            <Icon icon={PriorityIcon.editFill} disabled />
                        </Popover>
                    ) : (
                        <ButtonWithTooltip
                            tooltip={!report.isOldReport && texts.edit}
                            skin="text"
                            disabled={report.isOldReport}
                            onClick={() => onEdit(report)}
                            prefixIcon={PriorityIcon.editFill}
                        />
                    ))}
                <Link
                    skin="primary"
                    disabled={!report.isActive}
                    onClick={() => onRun(report.id.toString(), report.title, report.reportType)}
                    {...createDataTestId('reports-row-action-btn', true)}
                >
                    {texts.run}
                </Link>
                <MenuActions
                    isSameUser={report.userName === userName}
                    isOldReport={report.isOldReport}
                    onDuplicate={() => onDuplicate(report.id)}
                    onDelete={() => onDelete(report.id)}
                />
            </Flex>
        </div>
    );
};

export default RowActions;
